import React from "react";
import { Button } from "antd";
import {LANGUAGE} from "../../../constant";
import "./style.less";

export const PrimaryButton = props => {
    const { width, marginLeft, marginRight, text, handleOnClick, disabled, htmlType, loading=false, icon="", lang="en", marginBottom } = props;

    let btnClass;
    if(lang===LANGUAGE.ENGLISH){
	btnClass="primary-btn";
    }
    else{
	btnClass="primary-btn-rtl";
    }

    
    if(htmlType==="submit"){
	return(
		<Button className={`${btnClass} bold ${marginLeft} ${marginRight} ${width} fontsize16 ${marginBottom} p10`}  disabled={disabled} htmlType={htmlType} loading={loading}>
		{text}
            </Button>
	);
    }
    else if(icon){
	return(
		<Button className={`${btnClass} bold ${marginLeft} ${marginRight} ${width} fontsize16 ${marginBottom}`} onClick={handleOnClick} disabled={disabled} loading={loading}>
		<img src={icon}  className="mr10 ml10" alt="agree"/> <span>{text}</span>
		</Button>
	);
    }
    return (
	    <Button className={`${btnClass} bold ${marginLeft} ${marginRight} ${width} fontsize16 ${marginBottom} p10`} onClick={handleOnClick} disabled={disabled} loading={loading}>
            {text}
        </Button>
    );
    
};


export const SecondaryButton = props => {
    const { width, marginLeft, marginRight, text, handleOnClick, htmlType, disabled, loading=false } = props;
    if(htmlType){
	return (
		<div id="secondary-btn">
		<Button className={`secondary-btn bold white ${marginLeft} ${marginRight} ${width} fontsize16 p10`} onClick={handleOnClick} disabled={disabled} htmlType={htmlType}  loading={loading}>
		{text}
            </Button>
		</div>
	);
    }
    
    return (
	<div id="secondary-btn">
	    <Button className={`secondary-btn bold white ${marginLeft} ${marginRight} ${width} fontsize16 p10`} onClick={handleOnClick} disabled={disabled} loading={loading}>
            {text}
        </Button>
	    </div>
    );
    
};


export const SecondaryButtonOutline = props => {
    const { width, marginLeft, marginRight, text, handleOnClick, htmlType, disabled, loading=false } = props;
    if(htmlType){
	return (
		<div id="secondary-btn-outline">
		<Button className={`secondary-btn-outline bold white ${marginLeft} ${marginRight} ${width} fontsize16 p10`} onClick={handleOnClick} disabled={disabled} htmlType={htmlType}  loading={loading}>
		{text}
            </Button>
		</div>
	);
    }
    
    return (
	<div id="secondary-btn">
	    <Button className={`secondary-btn-outline bold white ${marginLeft} ${marginRight} ${width} fontsize16 p10`} onClick={handleOnClick} disabled={disabled} loading={loading}>
            {text}
        </Button>
	    </div>
    );
    
};


export const TertiaryButton = props => {
    const { width, marginLeft, marginRight, text, handleOnClick, disabled } = props;
    return (
	    <div id="tertiary-btn">
	    <Button className={`tertiary-btn bold white ${marginLeft} ${marginRight} ${width} fontsize16 p10`} onClick={handleOnClick} disabled={disabled}>
            {text}
        </Button>
	    </div>
    );
};


export const QuaternaryButton = props => {
    const { width, marginLeft, marginRight, text, handleOnClick, disabled, loading=false } = props;
    return (
	<div id="quaternary-btn">
	    <Button className={`quaternary-btn bold white ${marginLeft} ${marginRight} ${width} fontsize16`} onClick={handleOnClick} disabled={disabled} loading={loading}>
            {text}
        </Button>
	    </div>
    );
    
};

export const BindingButton = props => {
    const { width, marginLeft, marginRight, text, handleOnClick,  loading=false, icon="", lang="en", marginBottom } = props;

    let btnClass;
    if(lang===LANGUAGE.ENGLISH){
	btnClass="binding-btn";
    }
    else{
	btnClass="binding-btn-rtl";
    }
    
    if(icon){
	return(
		<Button className={`${btnClass} bold ${marginLeft} ${marginRight} ${width} fontsize16 ${marginBottom}`} onClick={handleOnClick}  loading={loading}>
		<img src={icon}  className="mr10 ml10" alt="agree"/> <span>{text}</span>
		</Button>
	);
    }
    return (
	    <Button className={`${btnClass} bold ${marginLeft} ${marginRight} ${width} fontsize16 ${marginBottom}`} onClick={handleOnClick}  loading={loading}>
            {text}
        </Button>
    );
};




export const BindingSubmit = props => {
    const { width, marginLeft, marginRight, text, handleOnClick, htmlType, disabled, loading=false } = props;
    if(htmlType){
	return (
		<div id="binding-submit-btn">
		<Button className={`binding-submit bold white ${marginLeft} ${marginRight} ${width} fontsize16`} onClick={handleOnClick} disabled={disabled} htmlType={htmlType}  loading={loading}>
		{text}
            </Button>
		</div>
	);
    }
    
    return (
	<div id="binding-submit-btn">
	    <Button className={`binding-submit bold white ${marginLeft} ${marginRight} ${width} fontsize16`} onClick={handleOnClick} disabled={disabled} loading={loading}>
            {text}
        </Button>
	    </div>
    );
    
};
